const skills = [
  { icon: 'ri-search-eye-line', title: 'Подготовка', desc: 'Цель, интересы, позиция, ограничения, альтернативы и возможные сценарии развития разговора.' },
  { icon: 'ri-scales-2-line', title: 'Аргументация', desc: 'Как объяснять позицию через факты, цели бизнеса и последствия, а не через давление и эмоции.' },
  { icon: 'ri-star-line', title: 'Влияние', desc: 'Как менять позицию другой стороны без постоянного давления — через доверие, авторитет и аргументы.' },
  { icon: 'ri-shield-check-line', title: 'Работа с сопротивлением', desc: 'Как понимать причины сопротивления и выбирать подходящую тактику вместо попытки «продавить».' },
  { icon: 'ri-anchor-line', title: 'Удержание позиции', desc: 'Как не уступать там, где уступка ухудшает результат бизнеса или ослабляет переговорную позицию.' },
  { icon: 'ri-swap-line', title: 'Работа с уступками', desc: 'Когда уступать, что просить взамен и как не превращать переговоры в одностороннее движение.' },
  { icon: 'ri-question-line', title: 'Вопросы', desc: 'Как получать информацию, которая помогает понять интересы другой стороны, а не только её заявленную позицию.' },
  { icon: 'ri-mental-health-line', title: 'Эмоциональная устойчивость', desc: 'Как сохранять контроль над собой в условиях давления, конфликта или неопределённости.' },
  { icon: 'ri-check-double-line', title: 'Завершение', desc: 'Как переводить разговор в конкретные договорённости со сроками, ответственностью и критериями результата.' },
];

export default function NegotiationSkills() {
  return (
    <section id="skills" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Навыки руководителя в переговорах
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Что необходимо уметь руководителю, чтобы добиваться результата и сохранять контроль над ситуацией
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {skills.map((s) => (
            <div key={s.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${s.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{s.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}